import axios from 'axios';
import apisUrls from '../urls';

const getAllDevicesApi = (paramsFilter) => {
  return axios.get(apisUrls?.getDevices);
};

export default getAllDevicesApi;
